import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import api from "../../../api/api";

export default function SprintTab({ projectId }) {
  const [sprints, setSprints] = useState([]);

  const [open, setOpen] = useState(false);

  const [form, setForm] = useState({
    name: "",
    goal: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    loadSprints();
  }, [projectId]);

  const loadSprints = async () => {
    try {
      const res = await api.get(`/projects/${projectId}/sprints`);
      setSprints(res.data);
    } catch (err) {
      console.error("Failed to load sprints", err);
    }
  };

  const createSprint = async () => {
    if (!form.name || !form.start_date || !form.end_date) return;

    try {
      await api.post(`/projects/${projectId}/sprints`, form);

      setOpen(false);
      setForm({
        name: "",
        goal: "",
        start_date: "",
        end_date: "",
      });

      loadSprints();
    } catch (err) {
      console.error("Sprint creation failed", err);
    }
  };

  return (
    <Box>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h6">Sprints</Typography>

        <Button variant="contained" onClick={() => setOpen(true)}>
          Create Sprint
        </Button>
      </Box>

      {sprints.length === 0 ? (
        <Typography color="text.secondary">
          No sprints created.
        </Typography>
      ) : (
        sprints.map((sprint) => (
          <Card key={sprint.id} sx={{ mb: 2 }}>
            <CardContent>
              <Typography fontWeight="bold">
                {sprint.name}
              </Typography>

              {sprint.goal && (
                <Typography variant="body2" color="text.secondary">
                  {sprint.goal}
                </Typography>
              )}

              <Typography variant="body2" color="text.secondary" mt={1}>
                {sprint.start_date} → {sprint.end_date}
              </Typography>

              <Box mt={1}>
                <Chip
                  label={sprint.status}
                  size="small"
                  color={sprint.status === "ACTIVE" ? "primary" : "default"}
                />
              </Box>
            </CardContent>
          </Card>
        ))
      )}

      {/* Create Sprint Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Create Sprint</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            label="Sprint Name"
            margin="normal"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Goal"
            margin="normal"
            value={form.goal}
            onChange={(e) =>
              setForm({ ...form, goal: e.target.value })
            }
          />

          <TextField
            label="Start Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={form.start_date}
            onChange={(e) =>
              setForm({ ...form, start_date: e.target.value })
            }
          />

          <TextField
            label="End Date"
            type="date"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={form.end_date}
            onChange={(e) =>
              setForm({ ...form, end_date: e.target.value })
            }
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={createSprint}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}